import { render, staticRenderFns } from "./merchantUpt.vue?vue&type=template&id=0a1ad62b&scoped=true&"
import script from "./merchantUpt.vue?vue&type=script&lang=js&"
export * from "./merchantUpt.vue?vue&type=script&lang=js&"
import style0 from "./merchantUpt.vue?vue&type=style&index=0&id=0a1ad62b&lang=scss&scoped=true&"
import style1 from "./merchantUpt.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1ad62b",
  null
  
)

export default component.exports